import clsx from "clsx";
import { isNil } from "lodash";

import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { formatting, type SalesMetricRow } from "@north-beam/nb-common";

export const getMetricComparison = (
  metric: SalesMetricV2,
  metrics: SalesMetricRow["metrics"],
  comparisonMetrics: SalesMetricRow["comparisonMetrics"],
  showPercentChange: boolean,
) => {
  const currentValue = metric.getValue(metrics);
  const comparisonValue = comparisonMetrics
    ? metric.getValue(comparisonMetrics)
    : undefined;

  if (isNil(currentValue) || isNil(comparisonValue)) {
    return <div>-</div>;
  }

  const deltaPercent = (currentValue - comparisonValue) / comparisonValue;

  if (isNaN(deltaPercent)) {
    return <div>-</div>;
  }

  const isPositiveTrend =
    (metric.positiveTrend === "up" && (deltaPercent ?? 0) > 0) ||
    (metric.positiveTrend === "down" && (deltaPercent ?? 0) < 0);

  const deltaClassName = clsx({
    "text-v2-action-positive": isPositiveTrend && metric.positiveTrend === "up",
    "text-v2-action-negative rotate-180":
      !isPositiveTrend && metric.positiveTrend === "up",
    "text-v2-action-positive rotate-180":
      isPositiveTrend && metric.positiveTrend === "down",
    "text-v2-action-negative":
      !isPositiveTrend && metric.positiveTrend === "down",
  });

  if (showPercentChange) {
    const percentageClassName = clsx("flex items-center gap-1", {
      "text-v2-action-positive": isPositiveTrend,
      "text-v2-action-negative": !isPositiveTrend,
    });

    return (
      <div className={percentageClassName}>
        {formatting.formatMetric(Math.abs(deltaPercent), "percentage", {
          precision: "approximate",
        })}
        <i className={clsx(deltaClassName, "fa-regular fa-arrow-up")} />
      </div>
    );
  }

  return (
    <div className={deltaClassName}>
      <i className="fa-regular fa-arrow-up" />
    </div>
  );
};
